module.exports = __webpack_public_path__ + "static/media/event_repeat_blue.06ac0f22.svg";